import styled from 'styled-components';

import { colors } from '@gbs-monorepo-packages/styles';

export const Wrapper = styled.div<{ $isInvalid?: boolean }>`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;

  [data-state='unchecked'] {
    border-color: ${({ $isInvalid }) =>
      $isInvalid ? colors.red300 : 'currentColor'};
  }
`;

export const Label = styled.label`
  color: ${colors.text};
  cursor: pointer;
  font-size: 0.875rem;
  line-height: 1.5;
  user-select: none;
`;

export const Link = styled.a`
  color: ${colors.blue500};
  font-weight: 700;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const ErrorMessage = styled.span`
  color: ${colors.red300};
  font-size: 0.875rem;
`;
